import i18n from "@/locales/i18n";

export function loadWorldMap() {
  (function($, window, document) {
    $(document).ready(function() {
      $("#image-map-pro-containerMap").imageMapPro({
        id: 7896,
        editor: {
          tool: "select",
          shapeCounter: { spots: 6, ovals: 2, texts: 4 }
        },
        general: {
          name: "Map",
          shortcode: "Map",
          width: 6558,
          height: 3334,
          naturalWidth: 6558,
          naturalHeight: 3334,
          center_image_map: 1
        },
        image: { url: require("@/assets/images/map_world.jpg") },
        fullscreen: {
          fullscreen_button_position: 2,
          fullscreen_button_type: "icon"
        },
        shapes: {
          glow_opacity: 0.8374233128834356,
          stop_glowing_on_mouseover: 0
        },
        tooltips: {
          constrain_tooltips: 0,
          tooltip_animation: "fade",
          fullscreen_tooltips: "none"
        },
        zooming: { enable_navigator: 0 },
        spots: [
          {
            id: "spot-4998",
            title: "Deutschland",
            x: 37.987,
            y: 35.592,
            width: 55,
            height: 55,
            x_image_background: 37.987,
            y_image_background: 35.592,
            default_style: {
              icon_type: "custom",
              icon_fontawesome_id: "comments",
              icon_url: require("@/assets/images/map_focus.png"),
              icon_is_pin: 0
            },
            tooltip_style: {
              background_color: "#00aeef",
              position: "right",
              width: 396,
              auto_width: 0,
              offset_x: 0.32002896081773,
              offset_y: 0.15542080258385482
            },
            tooltip_content: {
              squares_settings: {
                containers: [
                  {
                    id: "sq-container-398761",
                    settings: {
                      elements: [
                        {
                          settings: {
                            name: "Heading",
                            iconClass: "fa fa-header"
                          },
                          options: {
                            heading: {
                              text: i18n.t("map_germany"),
                              heading: "h2"
                            }
                          }
                        },
                        {
                          settings: {
                            name: "Paragraph",
                            iconClass: "fa fa-paragraph"
                          },
                          options: {
                            text: {
                              text: i18n.t("map_germany_recommendations")
                            }
                          }
                        },
                        {
                          settings: { name: "Button", iconClass: "fa fa-link" },
                          options: {
                            button: {
                              text: i18n.t("more_information"),
                              link_to:
                                "http://regelwerke.vbg.de/vbg_trgs/trgs525/trgs525_45_.html",
                              new_tab: 1,
                              bg_color: "#ffffff",
                              text_color: "#000000"
                            }
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          },
          {
            id: "spot-7135",
            title: "Frankreich",
            x: 35.602,
            y: 22.201,
            width: 55,
            height: 55,
            x_image_background: 35.602,
            y_image_background: 22.201,
            default_style: {
              icon_type: "custom",
              icon_url: require("@/assets/images/map_focus.png"),
              icon_is_pin: 0
            },
            tooltip_style: {
              background_color: "#00aeef",
              position: "right",
              width: 396,
              auto_width: 0,
              offset_x: 0.23462478705280887,
              offset_y: -0.34234801704094764
            },
            tooltip_content: {
              squares_settings: {
                containers: [
                  {
                    id: "sq-container-248231",
                    settings: {
                      elements: [
                        {
                          settings: {
                            name: "Heading",
                            iconClass: "fa fa-header"
                          },
                          options: {
                            heading: {
                              text: i18n.t("map_france"),
                              heading: "h2"
                            }
                          }
                        },
                        {
                          settings: {
                            name: "Paragraph",
                            iconClass: "fa fa-paragraph"
                          },
                          options: {
                            text: {
                              text: i18n.t("map_france_recommendations")
                            }
                          }
                        },
                        {
                          settings: { name: "Button", iconClass: "fa fa-link" },
                          options: {
                            button: {
                              text: i18n.t("more_information"),
                              link_to:
                                "https://www.juritravail.com/codes/code-travail/article/R4222-12.html",
                              new_tab: 1,
                              bg_color: "#ffffff",
                              text_color: "#000000"
                            }
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          },
          {
            id: "spot-4802",
            title: "Dänemark",
            x: 50.424,
            y: 6.973,
            width: 50,
            height: 50,
            x_image_background: 50.424,
            y_image_background: 6.973,
            default_style: {
              icon_type: "custom",
              icon_url: require("@/assets/images/map_focus.png"),
              icon_is_pin: 0
            },
            tooltip_style: {
              background_color: "#00aeef",
              position: "bottom",
              width: 586,
              auto_width: 0,
              offset_x: -0.5332410562180527,
              offset_y: -2.1812049080158573
            },
            tooltip_content: {
              squares_settings: {
                containers: [
                  {
                    id: "sq-container-167071",
                    settings: {
                      elements: [
                        {
                          settings: {
                            name: "Heading",
                            iconClass: "fa fa-header"
                          },
                          options: {
                            heading: {
                              text: i18n.t("map_denmark"),
                              heading: "h2"
                            }
                          }
                        },
                        {
                          settings: {
                            name: "Paragraph",
                            iconClass: "fa fa-paragraph"
                          },
                          options: {
                            text: {
                              text: i18n.t("map_denmark_recommendations")
                            }
                          }
                        },
                        {
                          settings: { name: "Button", iconClass: "fa fa-link" },
                          options: {
                            button: {
                              text: i18n.t("more_information"),
                              link_to:
                                "https://amid.dk/en/regulations/working-environment-act/",
                              new_tab: 1,
                              bg_color: "#ffffff",
                              text_color: "#000000"
                            }
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          },
          {
            id: "spot-4150",
            title: "Kanada",
            x: 30.406,
            y: 29.68,
            width: 55,
            height: 55,
            x_image_background: 30.406,
            y_image_background: 29.68,
            default_style: {
              icon_type: "custom",
              icon_url: require("@/assets/images/map_focus.png"),
              icon_is_pin: 0
            },
            tooltip_style: {
              background_color: "#00aeef",
              position: "left",
              width: 289,
              auto_width: 0,
              offset_x: -0.10695144804088663,
              offset_y: -2.3288791406636946
            },
            tooltip_content: {
              squares_settings: {
                containers: [
                  {
                    id: "sq-container-692151",
                    settings: {
                      elements: [
                        {
                          settings: {
                            name: "Heading",
                            iconClass: "fa fa-header"
                          },
                          options: {
                            heading: {
                              text: i18n.t("map_canada"),
                              heading: "h2"
                            }
                          }
                        },
                        {
                          settings: {
                            name: "Paragraph",
                            iconClass: "fa fa-paragraph"
                          },
                          options: {
                            text: {
                              text: i18n.t("map_canada_recommendations")
                            }
                          }
                        },
                        {
                          settings: { name: "Button", iconClass: "fa fa-link" },
                          options: {
                            button: {
                              text: i18n.t("more_information"),
                              link_to:
                                "https://standards.globalspec.com/std/13146760/CSA Z305.13",
                              new_tab: 1,
                              bg_color: "#ffffff",
                              text_color: "#000000"
                            }
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          },
          {
            id: "spot-5746",
            title: "USA",
            x: 27.169,
            y: 36.373,
            width: 55,
            height: 55,
            x_image_background: 27.169,
            y_image_background: 36.373,
            default_style: {
              icon_type: "custom",
              icon_url: require("@/assets/images/map_focus.png"),
              icon_is_pin: 0
            },
            tooltip_style: {
              background_color: "#00aeef",
              position: "bottom",
              width: 350,
              auto_width: 0,
              offset_x: -0.06559582623509641,
              offset_y: 0.06987439698133358
            },
            tooltip_content: {
              squares_settings: {
                containers: [
                  {
                    id: "sq-container-442911",
                    settings: {
                      elements: [
                        {
                          settings: {
                            name: "Heading",
                            iconClass: "fa fa-header"
                          },
                          options: {
                            heading: { text: i18n.t("map_usa"), heading: "h2" }
                          }
                        },
                        {
                          settings: {
                            name: "Paragraph",
                            iconClass: "fa fa-paragraph"
                          },
                          options: {
                            text: {
                              text: i18n.t("map_usa_recommendations")
                            }
                          }
                        },
                        {
                          settings: { name: "Button", iconClass: "fa fa-link" },
                          options: {
                            button: {
                              text: i18n.t("more_information"),
                              link_to:
                                "https://www.osha.gov/SLTC/respiratoryprotection/index.html",
                              new_tab: 1,
                              bg_color: "#ffffff",
                              text_color: "#000000"
                            }
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          },
          {
            id: "spot-2947",
            title: "Australien",
            x: 72.825,
            y: 65.386,
            width: 55,
            height: 55,
            x_image_background: 72.825,
            y_image_background: 65.386,
            default_style: {
              icon_type: "custom",
              icon_url: require("@/assets/images/map_focus.png"),
              icon_is_pin: 0
            },
            mouseover_style: { background_color: "#000000" },
            tooltip_style: {
              background_color: "#00aeef",
              width: 551,
              auto_width: 0,
              offset_x: -0.32113245315161976,
              offset_y: 0.20656212636078308
            },
            tooltip_content: {
              squares_settings: {
                containers: [
                  {
                    id: "sq-container-454031",
                    settings: {
                      elements: [
                        {
                          settings: {
                            name: "Heading",
                            iconClass: "fa fa-header"
                          },
                          options: {
                            heading: {
                              text: i18n.t("map_australia"),
                              heading: "h2"
                            }
                          }
                        },
                        {
                          settings: {
                            name: "Paragraph",
                            iconClass: "fa fa-paragraph"
                          },
                          options: {
                            text: {
                              text: i18n.t("map_australia_recommendations")
                            }
                          }
                        },
                        {
                          settings: { name: "Button", iconClass: "fa fa-link" },
                          options: {
                            button: {
                              text: i18n.t("more_information"),
                              link_to:
                                "https://www.journal.acorn.org.au/cgi/viewcontent.cgi?article=1019&context=jpn",
                              new_tab: 1,
                              bg_color: "#ffffff",
                              text_color: "#000000"
                            }
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          },
          {
            id: "spot-7967",
            title: "Vereinigtes Königreich",
            x: 40.713,
            y: 19.072,
            width: 55,
            height: 55,
            x_image_background: 40.713,
            y_image_background: 19.072,
            default_style: {
              icon_type: "custom",
              icon_url: require("@/assets/images/map_focus.png"),
              icon_is_pin: 0
            },
            tooltip_style: {
              background_color: "#00aeef",
              position: "right",
              width: 321,
              auto_width: 0,
              offset_x: 0.402857325383323,
              offset_y: 0.06748360408841236
            },
            tooltip_content: {
              squares_settings: {
                containers: [
                  {
                    id: "sq-container-849671",
                    settings: {
                      elements: [
                        {
                          settings: {
                            name: "Heading",
                            iconClass: "fa fa-header"
                          },
                          options: {
                            heading: {
                              text: i18n.t("map_uk"),
                              heading: "h2"
                            }
                          }
                        },
                        {
                          settings: {
                            name: "Paragraph",
                            iconClass: "fa fa-paragraph"
                          },
                          options: {
                            text: {
                              text: i18n.t("map_uk_recommendations")
                            }
                          }
                        },
                        {
                          settings: { name: "Button", iconClass: "fa fa-link" },
                          options: {
                            button: {
                              text: i18n.t("more_information"),
                              link_to:
                                "https://www.google.de/url?sa=t&rct=j&q=&esrc=s&source=web&cd=1&cad=rja&uact=8&ved=2ahUKEwid15aegajjAhWgQkEAHZzfBYYQFjAAegQIARAC&url=https%3A%2F%2Fdentallawandethics.co.uk%2Fwp-content%2Fuploads%2F2016%2F03%2FMHRA-Guidance-on-the-safe-use-of-lasers-intense-light-source-systems-and-LEDs-2008.pdf&usg=AOvVaw3FztJd9J4ttDMmLG-JutkG",
                              new_tab: 1,
                              bg_color: "#ffffff",
                              text_color: "#000000"
                            }
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          }
        ]
      });
    });
  })(jQuery, window, document);
}
